import { ValidationError } from "sequelize"
import { MarkovStartvectorState } from "server/models"
import { GET, POST, DELETE, validate } from "client/store/utils"
import { LangType, MarkovExpressionParseVars } from "client/store"
import {
    MarkovStartvectorStateList,
    MarkovStartvectorStateValidation,
} from "./types"


export const LoadAllMarkovStartvectorStates = (startvectorId: number) => (
    GET(`/markovStartvectorState/startvectorId/${startvectorId}`)
    .then((states: MarkovStartvectorState[]) => {
        const stateList: MarkovStartvectorStateList = {}
        states.forEach((state) => {
            stateList[state.stateId] = state
        })
        return stateList
    })
)

export const LoadMarkovStartvectorStateById = (stateId: number, startvectorId: number) => (
    GET(`/markovStartvectorState/stateId/${stateId}/startvectorId/${startvectorId}`)
    .then((state: MarkovStartvectorState) => state)
)

export const GetMarkovStartvectorStateVariableUsage = (variableId: number) => {
    const variableIndex = `var_${variableId}`
    return GET(`/markovStartvectorState/variableUsage/${variableIndex}`)
    .then((states: MarkovStartvectorState[]) => {
        const stateExpressions: MarkovStartvectorState[] = []
        states.forEach((state) => {
            const variablesParsed = MarkovExpressionParseVars(state.expression)
            const variablesEqual = variablesParsed.find((row) => row === variableIndex)
            if (variablesEqual && variablesEqual.length) stateExpressions.push(state)
        })
        return stateExpressions
    })
}

export const SaveMarkovStartvectorState = (data: MarkovStartvectorState, lang: LangType) => (
    POST(
        "/markovStartvectorState/save",
        JSON.stringify(data),
    ).then((res) => {
        const error = res as ValidationError
        return <MarkovStartvectorStateValidation>validate(error, lang)
    })
)

export const DeleteMarkovStartvectorState = (stateId: number, startvectorId: number) => (
    DELETE(`/markovStartvectorState/delete/${stateId}/${startvectorId}`)
    .then((removedRows: number) => removedRows)
)
